import { adform_campaign_metadata } from "../../../../libs/node";
import { GetBannerDataProps } from "../types";
import { getReportingDateRestrictions } from "./getReportingDateRestrictions";

/**
 * Grabs banner data specific to selected creative for Adform report
 */
export async function getBannerData({ getOneCreativeData, creativeId, user, setAdformReportingCreativeData, setAdformReportingModalPresetData, setAdformReportingModalOpen }: GetBannerDataProps) {
  /* Creative object data is fetched and referenced */
  const creativeData = await getOneCreativeData({ variables: { id: creativeId, teamId: user.teamId } });
  /**
   * If tag has been previously requested, we can continue the report generation process
   * This ensures that a report is only generated for an existing Adform tag
   * */
  if (creativeData.data.readOneCreativeId.adserver.tagId) {
    /* Grab tagId from adserver object */
    const tagId = creativeData.data.readOneCreativeId.adserver.tagId;
    /* This updates the adformReportingCreativeData for analytics tracking purposes */
    setAdformReportingCreativeData({ id: creativeId, brandName: creativeData.data.readOneCreativeId.metadata.brandName, format: creativeData.data.readOneCreativeId.metadata.format, hasVideo: creativeData.data.readOneCreativeId.metadata.slides.filter((slide: any) => slide.media.mimeType.includes("video")).length > 0 });
    /* Make a POST request to our campaign metadata API to collect the metadata for this banner */
    const bannerData = await adform_campaign_metadata("banner", tagId);
    /* This allows us to set the correct start and current date for our calendar inside the modal */
    const { minDate, maxDate } = getReportingDateRestrictions("banner", bannerData);
    setAdformReportingModalPresetData({ scope: "banner", name: creativeData.data.readOneCreativeId.adName, id: bannerData.Id, dateRangeRestriction: { start: minDate, end: maxDate } });
    /* Our modal can open up now that we have all the initial information required set */
    setAdformReportingModalOpen(true);
  }
  /* If no tag has been previously requested, then exit the report generation process */
  if (!creativeData.data.readOneCreativeId.adserver.tagId) throw new Error("No tags exist for this creative. Please request tags before requesting a report.");
}
